module.exports = __webpack_public_path__ + "img/w-replay_task.eb6ee8e5.svg";